import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import AnyQuestion from "@/pages/faqs/FaqComponents/AnyQuestion";
import classes from "./FAQS.module.css";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { useTranslation } from "@i18n";
import stl from "@/pages/homePageV2/homePageComponents/components/FAQ/FAQV2.module.css";
import { PageNamesEnum } from "@/routes/routes";
import FAQ from "@/pages/homePageV2/homePageComponents/components/FAQ/FAQ";
var FaqPage = function FaqPage() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var faqs = useFullPageData(PageNamesEnum.PAGE_NAME__FaqPage);
  if (!faqs) return null;
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    linksForSearch: true,
    authenticationMsg: true
  }, /*#__PURE__*/React.createElement("section", {
    className: stl.faqPageWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.FAQPage
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.bannerBox
  }, /*#__PURE__*/React.createElement("h1", null, t("faqs", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement(FAQ, {
    faqs: faqs,
    faqsPage: true,
    isHomePage: false
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/React.createElement(AnyQuestion, null))));
};
export default FaqPage;